
import { defineComponent, onMounted, reactive, ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import vuex from '@/store'
// import {setMainAppGlobalState } from '@/qiankun'
export default defineComponent({
  components: {},
  setup() {
    const pageName = ref('我是首页')
    const menus = computed(() => vuex.state.menus)
    let userInfo: any = {}
    if (sessionStorage.getItem('__user')) {
      userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
    }
    const menuCodes = userInfo?.user.info?.menuCodes || []
    const hasHomePage = computed(() => menuCodes.indexOf('home') >= 0)
    const buttonMaps = {
      创建知识: false,
      导入客户: false,
      新建任务: false,
    }
    const tabArr = vuex.state.tabsArr
    const imgHeight = hasHomePage.value
      ? window.innerHeight - 20 - 58
      : window.innerHeight - 20 - 58
    const imgWidth = (imgHeight * 1.8).toFixed(2)
    handleButtonAuth()
    function handleButtonAuth() {
      if (hasHomePage.value) {
        if (tabArr.length <= 0) {
          vuex.commit('set_data', {
            tabsArr: [
              {
                key: 'home',
                name: '模特&home',
                url: '/homePage',
                parentKey: '',
                child: [],
              },
            ],
            activeTabName: '模特&home',
          })
        } else {
          vuex.commit('set_data', {
            tabsArr: tabArr,
            activeTabName: '模特&home',
          })
        }
        const indexMenus = userInfo?.user?.info?.menuInfos.find((item: any) => item.name === '首页')
        const homeButtons = indexMenus?.nexts || [] // 首页按钮的权限
        homeButtons.forEach((item: any) => {
          buttonMaps[item.name] = true
        })
      }
    }

    function addTab(tabItem: any) {
      let event = new CustomEvent('OPEN_TAB', {
        detail: {
          title: tabItem.title,
          url: tabItem.url,
        },
        bubbles: true,
        cancelable: true,
      })
      window.dispatchEvent(event)
    }

    function newTask() {
      addTab({
        key: '',
        title: '创建任务',
        url: '/crm/createTask',
        parentKey: '',
        child: [],
      })
    }
    function fastImport() {
      addTab({
        key: '',
        title: '导入客户',
        url: '/crm/UserTemplate',
        parentKey: '',
        child: [],
      })
    }
    function createKnowledge() {
      addTab({
        key: 'knowledgeTemplate',
        title: '知识模板',
        url: '/aivideo/discover',
        parentKey: '',
        child: [],
      })
    }

    return {
      pageName,
      newTask,
      fastImport,
      hasHomePage,
      createKnowledge,
      imgWidth,
      imgHeight,
      buttonMaps,
    }
  },
})
